import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'

interface RoleProtectedRouteProps {
  allowedRoles: string[]
  redirectTo?: string
}

export const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({ 
  allowedRoles, 
  redirectTo = '/' 
}) => {
  const { isAuthenticated, user } = useAuth()
  
  // If not authenticated, redirect to appropriate login page
  if (!isAuthenticated || !user) {
    // Check if this is an agent route to redirect to agent login
    if (allowedRoles.includes('agent')) {
      return <Navigate to="/agent/login" replace />
    }
    return <Navigate to="/auth/login" replace />
  }
  
  // Get user type from localStorage (set during login)
  const userType = localStorage.getItem('user_type') || 'company_owner'
  
  // Check if user's role is allowed
  if (!allowedRoles.includes(userType)) {
    // Redirect based on user type
    if (userType === 'agent') {
      return <Navigate to="/agent/dashboard" replace />
    } else {
      return <Navigate to="/dashboard" replace />
    }
  }
  
  return <Outlet />
}

export default RoleProtectedRoute